<template>
  <div>
    <div id="google-sign-in-button">
      <img class="cursor-pointer" src="@/assets/img/google.png" alt="google" @click="clickGoogle" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as jose from 'jose';

export default {
  name: 'Google',
  mounted() {
    // @第三方登入:建立 google 登入按鈕
    window.google.accounts.id.initialize({
      client_id: '766546037624-r963u4bdm5bbpbcmoq36ludv5gmukqm2.apps.googleusercontent.com',
      callback: this.signIn,
    });
  },
  methods: {
    ...mapActions('thirdPartyLoginModule', ['registerThirdParty']),
    signIn(credentialResponse) {
      // google 取得使用者資訊
      const googleUser = jose.decodeJwt(credentialResponse.credential);
      // google 取得驗證資料
      const id = googleUser.sub;
      const name = googleUser.family_name + googleUser.given_name;
      const image = googleUser.picture;
      console.log('res', googleUser);
      console.log('name', name);
      console.log('image', image);
      // 註冊/登入 lale
      this.registerThirdParty({ userId: id, type: 2 });
    },
    clickGoogle() {
      window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          // continue with another identity provider.
          console.log(notification.getNotDisplayedReason())
          document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
          window.google.accounts.id.prompt()

        }
      });
    }
  }
};
</script>

<style lang="scss">
#google-sign-in-button {
  // 修改 google 提供按鈕的預設樣式
  border: 1px solid rgb(180, 180, 180);
  border-radius: 8px;
  overflow: hidden;
  .abcRioButton {
    box-shadow: none;
  }
  .abcRioButtonIconImage,
  .abcRioButtonSvg {
    width: 30px !important;
    height: 30px !important;
  }
  .abcRioButtonIcon {
    padding: 10px !important;
  }
}
</style>
